import React from "react";
import ApiCommunityDirectoryPage from "./ApiCommunityDirectoryPage";

export default function Lebanese() {
  return (
    <ApiCommunityDirectoryPage
      community="Lebanese"
      eyebrow="Lebanese community guide"
      title="Lebanese favorites, businesses, and local essentials in San Antonio."
      
      tags={["Lebanese community", "San Antonio", "Local businesses"]}
      claimText="Want your business featured in the Lebanese community guide?"
      modalIdPrefix="lebanese-directory"
    />
  );
}
